import { makeStyles, Theme } from '@material-ui/core/styles';
import { black } from 'constants/colors';

export const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    display: 'flex',
    padding: '165px 0',
    flexDirection: 'column',
    alignItems: 'center',
  },
  placeholder: {
    marginTop: 27,
    color: black,
  },
}));
